import * as ACTION_TYPES from './Types';

const initialState = {
  pincodesData: {},
  message: '',
  error: null,
}

export const pincodeReducer = (state = initialState, action) => {
  switch (action.type) {

    case ACTION_TYPES.GETALLPINCODES_SUCCESS:
      return {
        ...state,
        pincodesData: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETALLPINCODES_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    case ACTION_TYPES.ADDPINCODE_SUCCESS:
    // case ACTION_TYPES.UPDATEPINCODE_SUCCESS:
    case ACTION_TYPES.CHANGE_PINCODE_ACTION_SUCCESS:
      return {
        ...state,
        pincodesData: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.ADDPINCODE_ERROR:
    // case ACTION_TYPES.UPDATEPINCODE_ERROR:
    case ACTION_TYPES.CHANGE_PINCODE_ACTION_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    default:
      return state;
  }
}
